export interface Answer {
  text: string
  uuid: string
  hint: null | string
  overrides: null
  order: number
  image: null | string
  showImage?: boolean
}

export enum Types {
  Single = 'single',
  Multiple = 'multiple',
  Dropdown = 'dropdown',
}
